const DEBUG_STORAGE_KEY = 'monster-buttle-debug';

interface DebugFlags {
  bossWeakened: boolean;
}

function loadDebugFlags(): DebugFlags {
  if (process.env.NODE_ENV === 'production') return { bossWeakened: false };
  try {
    const raw = localStorage.getItem(DEBUG_STORAGE_KEY);
    return { bossWeakened: false, ...JSON.parse(raw ?? '{}') };
  } catch {
    return { bossWeakened: false };
  }
}

export function isDebugBossWeakened(): boolean {
  return loadDebugFlags().bossWeakened === true;
}

export function setDebugBossWeakened(value: boolean): void {
  if (process.env.NODE_ENV === 'production') return;
  localStorage.setItem(DEBUG_STORAGE_KEY, JSON.stringify({ ...loadDebugFlags(), bossWeakened: value }));
}

export function clearDebugFlags(): void {
  if (process.env.NODE_ENV === 'production') return;
  localStorage.removeItem(DEBUG_STORAGE_KEY);
}
